import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  EventCardModel,
  Layout,
  MessageModel,
  SectionModel,
  TabModel,
  Partial
} from '@flocasts/experience-service-types'
import { AdComponentInputs } from 'src/app/shared/ads/ad/ad-component.interface'
import {
  AD_ADHESION_SIZE,
  AD_LEADERBOARD_LARGE_SIZE,
  AD_LEADERBOARD_SMALL_SIZE,
  AD_RECTANGLE_LARGE_SIZE,
  AD_SKIN_SIZE
} from 'src/app/shared/ads/ads.utility'
import { AdConfig } from 'src/app/shared/ads/advertising-service/ad-config'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { ResultsAnalyticsService } from '../../results-analytics.service'

/**
 * Result Index Layout Component
 */
@Component({
  selector: 'flo-results-list-view',
  templateUrl: './results-list-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultsListViewComponent implements OnInit {
  constructor(private readonly resultsAnalyticsService: ResultsAnalyticsService) {}

  ngOnInit() {
    this.resultsAnalyticsService.sendPageCall()
  }

  @Input()
  tabItems: TabModel<Layout | Partial | null>[] | undefined = []
  @Input()
  resultsSections: SectionModel<EventCardModel>[] = []

  @Input()
  messageModelSection: MessageModel

  @Input()
  geoBlockedIds: ReadonlyArray<number>

  @Input() searchTerm = ''

  @Input() isFilterOrSearchLoading = false

  @Output() search = new EventEmitter<string | null>()

  public handleSearch(searchTerm: string | null) {
    this.search.emit(searchTerm)
  }

  public trackById = trackById

  // Ads
  public AdComponent = import('../../../shared/ads/ad/ad.component').then(m => m.AdComponent)

  public leaderboardLargeAdProps: AdComponentInputs = {
    config: {
      adConfig: AdConfig('results/list/728x90_flex', AD_LEADERBOARD_LARGE_SIZE, 'results-list-leaderboard-large')
    }
  }

  public leaderboardSmallAdProps: AdComponentInputs = {
    config: {
      adConfig: AdConfig('results/list/728x90_flex', AD_LEADERBOARD_SMALL_SIZE, 'results-list-leaderboard-small')
    }
  }

  public rightRailAdProps: AdComponentInputs = {
    config: {
      adConfig: AdConfig('results/list/300x250_1', AD_RECTANGLE_LARGE_SIZE, 'results-list-right-rail-rectangle')
    }
  }

  public adhesionAdProps: AdComponentInputs = {
    config: {
      adConfig: AdConfig('results/list/adhesion', AD_ADHESION_SIZE, 'results-list-adhesion'),
      additionalOpts: { maxRefreshTime: 30000 }
    }
  }

  public adSkinProps: AdComponentInputs = {
    config: {
      adConfig: AdConfig('results/list/atf', AD_SKIN_SIZE, 'results-list-ad-skin')
    }
  }
}
